import type { ReactNode } from "react";

interface PublicLayoutProps {
  children: ReactNode;
}

export function PublicLayout({ children }: Readonly<PublicLayoutProps>) {
  return <div className="min-h-screen bg-background">{children}</div>;
}
